<div class="login-new" id="reset-password-container">
       <div class="onboarding-progress-container">
              <div class="onboarding-progress">
                     <span class="progress completed"></span>
                     <span class="progress completed"></span>
                     <span class="progress completed"></span>
                     <span class="progress active"></span>
                     <span class="progress"></span>
              </div>
              <p><strong>4</strong> of 5</p>
       </div>
       <div>
              <h5 class="onboarding-title">{{'details_about_your_org' | translate}}</h5>
       </div>
       <div>
              <form class="row">
                     <ds-textbox #orgNameField
                     [textboxInput]="orgNameConfig"
                     (valueChange)="orgNameChange($event)">
                     </ds-textbox>
                     <div class="eod-input mb-3" 
                     id="country-input">
                            <label for="country" class="form-label">{{'country' | translate }}<span>*</span></label>
                            <ng-select
                            [items]="countryList"
                            bindLabel="countryName"
                            bindValue="countryId"
                            [(ngModel)]="selectedCountryId"
                            (change)="onCountryChange()"
                            class="select-dropdown select-dropdown--lg"
                            [clearable]="false"
                            notFoundText="{{'no_data_available' | translate}}" 
                            name="country">
                            </ng-select>
                            @if(submitted && !selectedCountryId){<small class="helper-text">{{"country_is_required" | translate}}</small>}
                     </div>
                     @if(countryList && countryList.length>0){<ds-textbox
                     [textboxInput]="currencyConfig">
                     </ds-textbox>}
              </form>
       </div>
       <ds-button
              [buttonInput]="continueConfig"
              (btnClick)="onSubmit()"
       ></ds-button>
       <!-- <hr class="my-2"> -->
</div>